<template>
  <div class="card_field">
    <div
      :class="{
        red: maillInput == 'red',
        green: maillInput == 'green',
        blue: maillInput == 'blue',
      }"
      class="card_filed_con"
    >
      <p class="card_input_label">
        {{ label }}
        <img
          v-if="showTips"
          class="question_mail_icon"
          v-click-outside="hideMailPopover"
          @click="showMailPopover = true"
          src="@img/icon_question.png"
          alt=""
        />
      </p>
      <div v-if="showMailPopover" class="mail_popover common_popover rtl">{{ tipsText }}</div>
      <input
        class="card_input_content card_input_content_mail"
        :placeholder="placeholder"
        v-model="val"
        @input="updateValidateStatus"
        @blur="updateValidateStatus"
        @change="updateValidateStatus"
      />
      <img class="checkOk" v-if="maillInput == 'green'" src="@img/icon_primer_ok.png" />
    </div>
    <p class="errortext" v-show="maillErrortext != '' && maillInput == 'red'">
      {{ maillErrortext }}
    </p>
  </div>
</template>
<script>
import ClickOutside from 'vue-click-outside'

export default {
  props: {
    validateFunc: {
      type: Function,
      default: () => {},
    },
    showTips: {
      type: Boolean,
      default: false,
    },
    tipsText: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showMailPopover: false,
      maillInput: '',
      maillErrortext: '',
      val: '',
    }
  },
  directives: {
    ClickOutside,
  },
  methods: {
    hideMailPopover() {
      this.showMailPopover = false
    },
    updateValidateStatus(ev) {
      const val = this.validateFunc(this.val)

      if (val.valid) {
        this.maillInput = 'green'
        return true
      } else {
        if (ev.type == 'input') {
          this.maillInput = 'blue'
        } else {
          this.maillInput = 'red'
          this.maillErrortext = val.errorMsg
        }
        return false
      }
    },
    validate() {
      const val = this.validateFunc(this.val)
      if (val.valid) {
        this.maillInput = 'green'
      } else {
        this.maillInput = 'red'
        this.maillErrortext = val.errorMsg
      }
      return {
        valid: val.valid,
        value: this.val,
      }
    },
  },
}
</script>
<style lang="less" scoped>
.card_field {
  width: 100%;
  position: relative;
  font-size: 0;
  margin-bottom: 14px;
  .card_filed_con {
    background: #fff;
    border: 1px solid #eae9e9;
    height: 44px;
    border-radius: 8px;
    width: 100%;
    padding-left: 10px;
    position: relative;
    color: #9d9d9d;
    padding-top: 7px;
    .checkOk {
      position: absolute;
      width: 16px;
      height: 16px;
      top: 14px;
      right: 12px;
    }

    .card_input_label {
      font-size: 11px;
      height: 12px;
      width: 100%;
      margin-bottom: 2px;
      display: flex;
      align-items: center;
      .question_mail_icon {
        width: 12px;
        height: 12px;
        margin-left: 4px;
        cursor: pointer;
      }
    }
    .mail_popover {
      left: 40px;
    }

    .card_input_content {
      height: 18px;
      font-size: 15px;
      line-height: 18px;
      display: block;
      width: 80%;
      border: none;
      background-color: transparent;

      &::placeholder {
        color: #9d9d9d; /* 设置占位符字体颜色 */
      }
    }

    .card_show {
      position: absolute;
      height: 21px;
      width: auto;
      top: 12px;
      right: 9px;
    }

    .cardok {
      width: 18px;
      height: 13px;
      top: 17px;
      right: 13px;
    }

    &.red {
      border-color: rgba(223, 60, 60, 1);
      color: rgba(223, 60, 60, 1);
      position: relative;
      // &::after {
      //   content: '';
      //   position: absolute;
      //   top: 14px;
      //   right: 12px;
      //   width: 16px;
      //   height: 16px;
      //   .bg-image('icon_primer_fail');
      // }
    }

    &.blue {
      border-color: #3089ff;
      color: #3089ff;
    }

    &.green {
      border: 1px solid #1bc263;
    }
  }

  .errortext {
    font-size: 14px;
    color: rgba(223, 60, 60, 1);
    margin-left: 8px;
    margin-bottom: -8px;
  }
  &.fullwidth {
    width: 100%;
  }
}
@media (max-width: 1024px) {
  .card_field {
    width: 100%;
    margin-bottom: 10px;
    .card_filed_con {
      background: #fff;
      height: 44px;
      border: 1px solid #eae9e9;

      .card_input_label {
        font-size: 12px;
      }
    }
  }
}
</style>
